import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import * as $ from "jquery";
import { ToastrService } from "ngx-toastr";
import { Observable, of } from "rxjs";
import { mergeMap } from "rxjs/operators";
import {
  REMOVESPACESONLY,
  VALIDEMAILREGEX,
} from "src/app/helpers/helperResources";
import { ContactsModel } from "src/app/models/clients/contacts.model";
import { ClientService } from "src/app/services/client-services/clients.service";
import { CompaniesService } from "src/app/services/client-services/companies.service";
import { ContactCompanyImageService } from "src/app/services/client-services/contactImage.service";
import { ContactsService } from "src/app/services/client-services/contacts.service";
import { GeneralService } from "src/app/services/general.service";
import DateUtils from "src/app/utils/date";
import { selectConfig } from "src/app/utils/utils";

@Component({
  selector: 'app-create-contact-form',
  templateUrl: './create-contact-form.component.html',
  styleUrls: ['./create-contact-form.component.css']
})
export class CreateContactFormComponent implements OnInit {
  @Output() emitEvent = new EventEmitter();
  config = {
    search: true, // true/false for the search functionlity defaults to false,
    placeholder: "Companies", // text to be displayed when no item is selected defaults to Select,
    limitTo: 10, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    noResultsFound: "Type here to search", // text to be displayed when no items are found while searching
    searchPlaceholder: "search",
    displayKey: "name",
  };
  bsConfig = {
    dateInputFormat: "DD-MM-YYYY",
    selectFromOtherMonth: true,
    adaptivePosition: true,
  };
  today: Date = new Date();
  dateUtil = new DateUtils();
  teamConfig = { ...selectConfig, displayKey: "teamName" };
  multipleCompany = true;
  contactForm: FormGroup;
  teamID;
  validEmailRegex;
  children = [];
  addBtnName = "Add Child";
  childEditObject: any = {};
  arrayTeams: any;
  editChildIndex;
  companyDropdownOptions: Observable<any>;
  companysDetailArray = [];
  selectedCompanies;
  imgDetails = {
    previousImage: "",
    src: "/assets/img/default.png",
  };

  showAdditionalFields: boolean = false;
  loadingBtn: boolean = false;
  counter: number = 0;
  btnNext: string = "Save Contact";

  // Ayotunde
  createOwner = this.genServ.user.id;
  
  
  config2 = {
    search: true, // true/false for the search functionlity defaults to false,
    placeholder: "Select Option", // text to be displayed when no item is selected defaults to Select,
    limitTo: 10, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    noResultsFound: "No results found!", // text to be displayed when no items are found while searching
    searchPlaceholder: "search",
  };

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private contactServ: ContactsService,
    private genServ: GeneralService,
    private companyServ: CompaniesService,
    private contactImage: ContactCompanyImageService,
    private clientService: ClientService,
    private toastr: ToastrService
  ) {
    this.validEmailRegex = VALIDEMAILREGEX;
    this.createForm();
  }

  ngOnInit() {
    // this.getSalespersonTeams();
    this.companyDropdownOptions = null;
    // Child edit - Twoway binding Hack
    this.childEditObject = { ...this.contactForm.value.chidrenInfo };
    this.subscribeToPhoneNumberChanges();
  }

  get f() {
    return this.contactForm.controls;
  }

  get personalInfoForm() {
    return this.f.personalInfo;
  }

  // Get Contact Details
  private get contactDetails() {
    const contactForm = this.contactForm.value;
    let DOB = "";
    if (contactForm.personalInfo.dateOfBirth !== null)
      DOB =
        this.dateUtil.getDtPikerTimeStp(contactForm.personalInfo.dateOfBirth) +
        "";

    const otherInfo = {
      SMSNumber: contactForm.personalInfo.smsPhoneNumber,
      spouseDetails: {
        spouseName: contactForm.spouseInfo.spouseName || "",
        spousedateOfBirth: contactForm.spouseInfo.spousedateOfBirt || "",
        spousePhoneNumber: contactForm.spouseInfo.spousePhoneNumber || "",
        spouseSpecialAnniversary:
          contactForm.spouseInfo.spouseSpecialAnniversary || "",
      },
      childrenDetails: this.children || [],
    };

    return {
      leadId: 0,
      title: contactForm.personalInfo.title === 'Others' ? contactForm.personalInfo.otherTitle : contactForm.personalInfo.title,
      firstName: contactForm.personalInfo.firstName,
      surName: contactForm.personalInfo.lastName,
      otherName: contactForm.personalInfo.otherName || "",
      dateOfBirth: DOB || "",
      gender: contactForm.personalInfo.gender,
      maritalStatus: contactForm.personalInfo.maritalStatus,
      maidenName: contactForm.personalInfo.maidenName || "",
      occupation: "",
      owner: this.createOwner,
      officialPhoneNumber: contactForm.personalInfo.officalPhoneNumber,
      personalPhoneNumber: contactForm.personalInfo.personalPhoneNumber || "",
      email: contactForm.personalInfo.officialEmail,
      otherEmail: contactForm.personalInfo.personalEmail || "",
      postalAddress: "",
      fax: "",
      zip: "",
      stateOfOrigin: "",
      nextOfKin: "",
      nextOfKinRelationship: "",
      otherInfo,
      profileImage: this.imgDetails.src || "",
      customFields: contactForm.customFields ? contactForm.customFields : {}
    };
  }

  // Get companys
  private get fetchCompaniesId() {
    const selectedCompanies = [];
    this.contactForm.value.personalInfo.companyName.forEach((element) => {
      selectedCompanies.push(
        ...this.companysDetailArray.filter((res) => res.name === element)
      );
    });
    return selectedCompanies;
  }

  createForm() {
    this.contactForm = this.fb.group({
      personalInfo: this.fb.group({
        title: [""],
        otherTitle: [""],
        firstName: ["", [Validators.required, REMOVESPACESONLY]],
        lastName: ["", [Validators.required, REMOVESPACESONLY]],
        officialEmail: [
          "",
          Validators.compose([Validators.pattern(this.validEmailRegex)]),
        ],
        personalEmail: [
          "",
          Validators.compose([Validators.pattern(this.validEmailRegex)]),
        ],
        officalPhoneNumber: ["", Validators.pattern("^[0-9]{10}$")],
        personalPhoneNumber: ["", Validators.pattern("^[0-9]{11}$")],
        smsPhoneNumber: ["", Validators.pattern("^[0-9]{11}$")],
        companyName: [null],
        dateOfBirth: [""],
        profile: [""],
        otherName: [""],
        maidenName: [""],
        gender: [""],
        maritalStatus: [""],
        team: [""],
      }),
      spouseInfo: this.fb.group({
        spouseName: [""],
        spousedateOfBirth: [""],
        spousePhoneNumber: ["", Validators.pattern("^[0-9]{11}$")],
        spouseSpecialAnniversary: [""],
      }),
      chidrenInfo: this.fb.group({
        childrenName: [""],
        childrenOfBirth: [""],
      }),
    });
  }

  subscribeToPhoneNumberChanges() {
    this.contactForm.get('personalInfo.officalPhoneNumber').valueChanges.subscribe(value => {
      const formattedValue = this.formatPhoneNumber(value);
      this.contactForm.get('personalInfo.officalPhoneNumber').setValue(formattedValue, { emitEvent: false });
    });
  }

  formatPhoneNumber(value: string): string {
    if (!value) {
      return value;
    }

    if (value.startsWith('+234')) {
      value = value.substring(4);
    } else if (value.startsWith('234')) {
      value = value.substring(3);
    }

    if (value.startsWith('0')) {
      value = value.substring(1);
    }

    return value;
  }
  

  getToday(): string {
    return new Date().toISOString().split("T")[0];
  }

  checkCompanySelection() {
    const contactForm = this.contactForm.value;
    if (contactForm.personalInfo.companyName.length === 0) {
      this.multipleCompany = false;
      this.selectedCompanies = [];
    } else {
      this.multipleCompany = true;
      this.selectedCompanies = this.fetchCompaniesId;
    }
  }

  addChild() {
    const child = this.contactForm.value.chidrenInfo;
    if (this.addBtnName === "Add Child") {
      this.children.push(child);
    } else {
      this.children[this.editChildIndex] = child;
      this.addBtnName = "Add Child";
    }
    this.contactForm.controls.chidrenInfo.reset();
  }

  editChild(index) {
    this.childEditObject = this.children[index];
    this.editChildIndex = index;
    this.addBtnName = "Update Child";
  }

  removeChild(child) {
    this.children.splice(this.children.indexOf(child), 1);
  }

  onShowAdditionalFields() {
    this.showAdditionalFields = !this.showAdditionalFields;
  }

  async onSubmit() {
    try {
      this.loadingBtn = true;
      const body = this.contactDetails;

      const selectedCompanies = this.contactForm.value.personalInfo.companyName;
      const { payload, success } = await this.contactServ
        .createContacts(body)
        .toPromise();

      if (!success) return this.toastr.error(payload);
      // ELSE
      if (selectedCompanies != null) {
        // const selectedCompanyIds = this.fetchCompaniesId;

        selectedCompanies.map(async (result) => {
          const companyPayload = {
            companyId: result.clientId,
            contactId: payload.clientId,
          };
          const { response, success } = await this.addCompanyToContact(
            companyPayload
          );
          if (!success) return this.toastr.error(response);
        });
        // this.toastr.success("Company(ies) added successfully!", "Success!");
      }
      this.toastr.success("Contact created successfully!", "Success");
      // this.router.navigate(["clients/contacts-list"]);
      this.contactForm.reset();
      this.emitEvent.emit({status: 'success'})
    } catch (error) {
      this.toastr.error("Something wrong happened. Please try again!");
    } finally {
      this.loadingBtn = false;
    }
  }

  async addCompanyToContact(payload) {
    if (!payload) return;
    return await this.contactServ.addCompanyToContact(payload).toPromise();
  }

  async createContactOld(body) {
    this.loadingBtn = true;
    this.contactServ
      .createContacts(body)
      .subscribe(
        async (res) => {
          const { payload, success } = res;
          if (success) {
            const selectedCompanyIds = this.fetchCompaniesId;
          } else {
            this.toastr.error(
              "Something went wrong. Please try again!",
              "Oops"
            );
          }
        },
        (error) => {
          this.toastr.error("Something went wrong!", "Oops");
        }
      )
      .add(() => {
        this.contactForm.reset();
        this.loadingBtn = false;
      });
  }

  // Create Contact
  handleContactCreation() {
    const contactDetails = this.contactDetails;
    // this.loadingView = true;
    $("#ModalCenter4 .close").click();
    this.genServ.sweetAlertFileCreations("Contact").then((res) => {
      if (res.value) {
        this.contactServ.createContacts(contactDetails).subscribe((response) => {
        const { success, payload } = response;
        if (success) {
          // Add Company to contact
          const selectedCompanyIds = this.fetchCompaniesId;
          selectedCompanyIds.map((result) => {
          const companyPayload = {
              companyId: result.id,
              contactId: payload.clientId,
          };
          this.contactServ.addCompanyToContact(companyPayload).subscribe((res2) => {
            const { success: contactSuccess } = res2;
            if (contactSuccess) {
              this.toastr.success('Contact created successfully')
            } else {
              this.genServ.sweetAlertFileCreateErrorWithoutNav("Contact");
            }
          }, (error) => {
            this.toastr.error('Error creating contact')
          }
        );
      });
         this.contactForm.reset();
        }
      });
  }
    });
  }

  async onImageUpload(event) {
    if (event.target.files.length > 0) {
      const image = event.target.files[0];
      this.imgDetails.src = window.URL.createObjectURL(image);
      await this.uploadContactPhoto(event);
    }
  }

  // UPLOAD CONTACT PHOTO TO GET IMAGE URL

  async uploadContactPhoto(event) {
    if (event.target.files.length > 0) {
      const image = event.target.files[0];
      const formData = new FormData();
      formData.append("image", image);
      formData.append("previousImageName", this.imgDetails.previousImage);
      this.contactImage.createImage(formData).subscribe(
        async (res) => {
          const { payload, success } = res;
          if (success) {
            this.imgDetails.previousImage = payload.imageName;
            this.imgDetails.src = payload.request.uri;
            // $("#imagePreview").hide();
            // $("#imagePreview").fadeIn(650);
          } else
            this.toastr.error(
              "Error uploading photo! Please try again.",
              "Oops!"
            );
        },
        (err) => {
          this.toastr.error(
            "Error uploading photo! Please try again.",
            "Oops!"
          );
        }
      );
    }
  }

  // WIZARD FUNCTION BEGINS HERE
  onNext() {
    if (this.counter === 1) {
      this.btnNext = "Create Contact";
      this.counter++;
    } else if (this.counter === 2) {
      this.onSubmit();
    } else {
      this.btnNext = "Continue";
      this.counter++;
    }

    // if (this.counter != 3 - 1) {
    //   this.btnNext = "Continue";
    //   this.counter++;
    // } else this.btnNext = "Create Contact";
  }

  onPrevious() {
    if (this.counter > 0) {
      this.btnNext = "Save Contact";
      this.counter--;
    }
  }

  validateNumber(event) {
    const keyCode = event.keyCode;
    const excludedKeys = [8, 37, 39, 46];

    if (
      !(
        (keyCode >= 48 && keyCode <= 57) ||
        (keyCode >= 96 && keyCode <= 105) ||
        excludedKeys.includes(keyCode)
      )
    ) {
      event.preventDefault();
    }
  }

  clientLookUp(value) {
    if (!value) {
      return;
    }
    this.config.noResultsFound = "No results found!";
    this.companyDropdownOptions = this.companyServ
      .getCompanyWildcard(value)
      .pipe(
        mergeMap((data: { payload: any[] }) => {
          if (!data.payload.length) {
            this.updateNoResultText();
          }
          const result = data.payload.map((dat) => dat);
          return of(result);
        })
      );
  }

  updateNoResultText() {
    const el = document.querySelector(
      ".ngx-dropdown-container .ngx-dropdown-list-container ul li:last-child"
    );
    el.textContent = "No results found!";
  }
}
